import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { ensureDeviceFingerprint, getDeviceFingerprint } from '@admin-panel/utils';
import { hydrateSynqSentryUserFromStorage } from '@admin-panel/observability';

import App from './app/app';
import { initSynqSentry } from './sentry';

import './styles/main.css';

const tracePropagationTargets = ['localhost'];

for (const apiUrl of [import.meta.env.VITE_GATEWAY_API_URL, import.meta.env.VITE_STYLIST_API_URL]) {
  if (!apiUrl) {
    continue;
  }

  try {
    tracePropagationTargets.push(new URL(apiUrl).origin);
  } catch {
    // Ignore invalid URLs in local env config.
  }
}

initSynqSentry(tracePropagationTargets);

const bootstrap = async () => {
  await ensureDeviceFingerprint();
  Sentry.setTag('device_id', getDeviceFingerprint());
  hydrateSynqSentryUserFromStorage();

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
};

void bootstrap();
